import _ from 'lodash';
import React, { Component } from 'react';
import { MegadraftEditor, editorStateFromRaw, DraftJS, createTypeStrategy } from 'megadraft';
import imagePlugin from 'megadraft/lib/plugins/image/plugin.js';
import customImagePlugin from '../plugins/CustomImagePlugin/plugin';
import YoutubePlugin from '../plugins/YoutubePlugin/plugin';

function TargetBlankLink({ entityKey, children, contentState }) {
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <a
      className="editor__link"
      href={url}
      title={url}
      target="_blank"
      rel="noopener"
    >
      {children}
    </a>
  );
}

// TargetBlankLink.propTypes = {
//   entityKey: PropTypes.string.isRequired,
//   children: PropTypes.any.isRequired,
//   contentState: PropTypes.any.isRequired,
// };

const decorators = new DraftJS.CompositeDecorator([
  {
    strategy: createTypeStrategy('LINK'),
    component: TargetBlankLink,
  },
]);

class DecoratedEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { entry } = this.props;
    return (
      <MegadraftEditor
        editorState={editorStateFromRaw(JSON.parse(entry.json), decorators)}
        readOnly
        plugins={[imagePlugin, customImagePlugin, YoutubePlugin]}
      />
    );
  }
}

export default DecoratedEditor;
